/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} St_Wl_SubmitInputs */

const en_st_wl_submit = /** @type {(inputs: St_Wl_SubmitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Join the waitlist`)
};

const id_st_wl_submit = /** @type {(inputs: St_Wl_SubmitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Daftar waitlist`)
};

/**
* | output |
* | --- |
* | "Join the waitlist" |
*
* @param {St_Wl_SubmitInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const st_wl_submit = /** @type {((inputs?: St_Wl_SubmitInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<St_Wl_SubmitInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_st_wl_submit(inputs)
	return en_st_wl_submit(inputs)
});